import styled from 'styled-components';

export const AgentFlowParameterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  min-height: 43px;
  padding: 0 0 8px 0;
`;
export const AgentFlowParameterLabelWrapper = styled.div`
  padding: 0 12px 0 0;
  min-width: ${({ IsLongLabel }) => (IsLongLabel ? '180px' : '110px')};
`;
export const AgentFlowParameterInlineButtonWrapper = styled.div`
  padding-left: 8px;

  button {
    padding: 6.5px 12px;
  }
`;
export const AgentFlowTextarea = styled.textarea`
  min-height: 66px !important;
  resize: vertical;
`;
export const AgentFlowSVGIconButton = styled.div`
  width: ${({ size }) => size || '24px'};
  height: ${({ size }) => size || '24px'};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  margin-left: 8px;

  svg {
    width: ${({ size }) => size || '24px'};
    height: ${({ size }) => size || '24px'};

    fill: ${({ theme }) => theme.themeColors.text};
  }
`;
